export const data = [
    {
        title: 'Terms of use',
        blocks: [
            'Access to and use of this website is subject to the following requirements. Please do not use this website if you do not agree to these terms. This website was developed and is operated by the UniferX group of companies.',
            'We reserve the right to discontinue this site or to make changes to this site or to the Terms of Use, in whole or in part. Please note that we may make such changes at our sole discretion without prior notice. Therefore, we ask you: the next time you visit our website, please review the terms and conditions again and note any changes or corrections that may have been made.',
        ],
    },
    {
        title: 'Refusal of use',
        blocks: [
            'All information, documents, illustrations and videos on this website are the sole property of the UniferX Group.',
            'Any use of the information, documents, illustrations and videos is only possible with the written permission of the UniferX Group.',
        ],
    },
    {
        title: 'Trademarks and copyright',
        blocks: [
            'All trademarks on this website are the property of the UniferX group of companies, unless otherwise stated or otherwise identified as the right of a third party.',
            'Any unauthorized use of these trademarks or other materials, which is expressly prohibited, is considered a violation of copyright, trademark law or other industrial property rights.',
        ],
    },
    {
        title: 'Limited liability',
        blocks: [
            'The information on this website is intended solely for the purpose of presenting the UniferX group of companies, its products and services. However, no representation or warranty is made, express or implied, as to the completeness or accuracy of the information contained on this website.',
            'Therefore, we recommend that you verify any information on this website before relying on it. The advice provided on this website does not relieve you of the need to conduct your own due diligence on our advice and data.',
        ],
    },
    {
        title: 'Third-party websites / links',
        blocks: [
            'The information provided on this website is constantly checked and updated. Despite all due diligence, changes in the data may occur. Consequently, we cannot be held responsible for or guarantee the timeliness and accuracy of the information provided. Identical rules apply to all other websites that you can access through the link.',
            'Important note for all links on our website: 312 O 85/98 by the decision of the District Court in Hamburg on May 12, 1998. "Liability for links", it was established that liability may be incurred for any link that contains a linked site, unless an explicit disclaimer of liability for the content of the links is made.',
        ],
    },
    {
        title: 'Personal data',
        blocks: [
            'You can use our website without disclosing your personal information.',
            'You are not required to provide personal information as a condition of using our website, except when it is necessary to provide you with products or services at your request.',
        ],
    },
];

export const titles = ['Privacy policy', ...data.map(item => item.title)];
